module.exports = __webpack_public_path__ + "static/media/resolutionCloud.18feb78e.svg";